<template>
  <div class="training-form view">
    <form v-if="entity" class="row" @submit.prevent="onSave({close: false})">
      <div class="col">

        <form-model-controls :docs="actionDocs" v-model="entity"/>

        {{ $t('Categories') }}
        <category-selector
            :categories="categories"
            v-model="entity.categories"
        />
      </div>
      <div class="col-5">
        <label>{{ $t('trainings_dates') }}</label>
        <sortable-list :items="entity.training_dates">
          <template v-slot:header="{toggleDirection, setNumericSort,setSortKey, sortKey, sortDirection}">
            <div class="row">
              <sortable-list-column-header
                  class="col-4"
                  sort-key="date"
                  :sort-a-s-c="sortDirection"
                  :sort-by="sortKey"
                  :set-sort-key="setSortKey"
                  :toggle-direction="toggleDirection"
              />
              <sortable-list-column-header
                  class="col-3"
                  sort-key="location"
                  :sort-a-s-c="sortDirection"
                  :sort-by="sortKey"
                  :set-sort-key="setSortKey"
                  :toggle-direction="toggleDirection"
              />
              <sortable-list-column-header
                  class="col-3"
                  sort-key="modified"
                  :sort-a-s-c="sortDirection"
                  :sort-by="sortKey"
                  :set-sort-key="setSortKey"
                  :toggle-direction="toggleDirection"
              />

            </div>
          </template>
          <template v-slot:itemTemplate="{item}">
            <div class="row align-items-center">
              <div class="col-3">
                {{ item.date }}<br>
                {{ item.duration }}
              </div>
              <div class="col-3">
                {{ item.location }}
              </div>
              <div class="col-3">
                {{ item.speakers.map(el => el.name).join(', ') }}
              </div>
              <div class="col-3 pr-0">
                <router-link class="btn btn-primary btn-block"
                             :to="['/regions', regionId, 'trainings', trainingId, 'training-date','edit', item.id].join('/')"
                >
                  {{ $t('edit') }}
                </router-link>
              </div>
            </div>
          </template>
          <template v-slot:emptyList>
            <empty-list-note
                :body-text="$t('Es gibt noch keine Termine für dieses Training')"
            />
          </template>
        </sortable-list>
        <div class="text-center">
          <router-link class="btn btn-primary"
                       :to="['/regions', regionId, 'trainings', trainingId,'training-date','new'].join('/')"
          >
            {{ $t('new training date') }}
          </router-link>
        </div>
      </div>
      <div class="col-12 py-5">
        <bottom-tool-bar :can-delete="!!trainingId" @save="onSave" @delete="onDelete"/>
      </div>
    </form>
    <div v-else class="text-center">
      <img src="/img/loading.svg" alt="loading">
    </div>

    <confirmation-modal v-if="showDirtyModal"
                        :title="$t('Achtung')"
                        @close="cancelNavigation">
      <template v-slot:default>
        {{ $t('Sie haben ungespeicherte Änderungen. Wie wollen Sie fortfahren?') }}
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-danger" @click="dontSave">
          {{ $t('Nicht speichern') }}
        </button>
        <button type="button" class="btn btn-primary" @click="onSave({close:true})">
          {{ $t('Speichern') }}
        </button>
      </template>
    </confirmation-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
// Mixins
import ViewDirtyMixin from '@/mixins/view-dirty'
// Components
// import FormInput from "@/components/Form/FormInput";
// import FormTextarea from "@/components/Form/FormTextarea";
import SortableList from "@/components/SortableList";
import EmptyListNote from "@/components/EmptyListNote";
import ConfirmationModal from "@/components/ConfirmationModal";
import SortableListColumnHeader from "@/components/SortableListColumnHeader";
// import RichTextEditor from "@/components/RichTextEditor";
import CategorySelector from "@/components/CategorySelector";
import FormModelControls from "@/components/Form/FormModelControls";
import BottomToolBar from "@/components/BottomToolBar";

export default {
  name: "TrainingForm",
  mixins: [ViewDirtyMixin],
  components: {
    BottomToolBar,
    FormModelControls,
    CategorySelector,
    // RichTextEditor,
    SortableListColumnHeader,
    ConfirmationModal,
    EmptyListNote,
    SortableList,
    // FormTextarea,
    // FormInput
  },
  props: {
    regionId: {type: String, default: null},
    trainingId: {type: String, default: null},
    trainingType: {type: String, default: null},
  },
  data() {
    return {
      entity: null,
    }
  },
  computed: {
    ...mapState({
      categories: state => state.Api.Categories.all
    }),
    actionDocs() {
      if (this.trainingId) {
        return this.$apiData.Trainings.find(action => action.name === 'modify')
      }

      return this.$apiData.Trainings.find(action => action.name === 'add')
    }
  },
  created() {
    this.allCategories({region_id: this.regionId}).catch(this.apiErrorHandler)
    if (this.trainingId) {
      this.entity = null;
      this.getTraining({id: this.trainingId})
          .then(training => {
            this.entity = training;
          })
          .catch(this.apiErrorHandler)
    } else {
      this.entity = {
        region_id: this.regionId,
        type: this.trainingType,
        sorting: 1
      }
    }
  },
  methods: {
    ...mapActions({
      addTraining: "Api/Trainings/add",
      getTraining: "Api/Trainings/get",
      modifyTraining: "Api/Trainings/modify",
      deleteTraining: "Api/Trainings/delete",
      allCategories: "Api/Categories/all",
    }),
    onSave({close}) {
      if (this.trainingId) {
        this.modifyTraining(this.entity)
            .then(close ? this.saveComplete : this.saveCompleteToast)
            .catch(this.apiErrorHandler);
      } else {
        this.addTraining(this.entity)
            .then(close ? this.saveComplete : entity => {
              this.saveCompleteToast();
              this.entity = entity;
              this.$router.replace(['/regions', this.regionId, 'trainings/edit', entity.id].join('/'))
            })
            .catch(this.apiErrorHandler);
      }
    },
    onDelete() {
      this.deleteTraining({id: this.trainingId})
          .then(this.saveComplete)
          .catch(this.apiErrorHandler);
    }
  }
}
</script>
